export default __webpack_public_path__ + "static/media/poi-drivingLicense.b4a241df.png";